import logo from "../assets/COMCARE.png";
import phone from "../assets/phone-call.png";
import address from "../assets/location.png";
import mail from "../assets/email.png";
import { Link } from "react-router-dom";

const scrollToTop = () => window.scrollTo(0, 0);

function Footer(){
    return(
        <>
        <footer id="contact" className="footer">
          <article className="container">
            <article className="grid lg:grid-cols-5 gap-3 text-[#bbbbbb]">
              <article className="footer-col col-span-2">
                <Link to="/" onClick={scrollToTop}>
                  <img
                    className="footer-logo"
                    src={logo}
                    alt="247comcare logo"
                  />
                </Link>
                <ul>
                  <li className="foot-li">
                    <img
                      className="footer-icon"
                      src={address}
                      alt="location icon"
                    />{" "}
                    <p className="ml-3">Lagos Nigeria</p>{" "}
                  </li>
                  <li className="foot-li">
                    <img className="footer-icon" src={mail} alt="mail icon" />{" "}
                    <a href="mailto:hello@247comcare.com" className="ml-3 hover:text-white transition-colors">hello@247comcare.com</a>{" "}
                  </li>
                  <li className="foot-li">
                    <img className="footer-icon" src={phone} alt="phone icon" />{" "}
                    <a href="tel:+2349161980940" className="ml-3 hover:text-white transition-colors">+234 916 198 0940</a>
                  </li>
                </ul>
              </article>
              <article className="footer-col">
                <h4>Company</h4>
                <ul>
                  <li>
                    <a href="#about" className="hover:text-white transition-colors">About us</a>
                  </li>
                  <li>
                    <a href="#services" className="hover:text-white transition-colors">Services</a>
                  </li>
                  <li>
                    <a href="#contact" className="hover:text-white transition-colors">Contact Us</a>
                  </li>
                </ul>
              </article>
              <article className="footer-col">
                <h4>Resources</h4>
                <ul>
                  {/* <li><Link to="/faqs" onClick={scrollToTop} className="hover:text-white transition-colors">FAQs</Link></li> */}
                  {/* <li><Link to="/privacy-policy" onClick={scrollToTop} className="hover:text-white transition-colors">Privacy Policy</Link></li> */}
                  <li><Link to="/code-of-practice" onClick={scrollToTop} className="hover:text-white transition-colors">Code of Practice</Link></li>
                  {/* <li><Link to="/terms-and-conditions" onClick={scrollToTop} className="hover:text-white transition-colors">Terms & Conditions</Link></li> */}
                </ul>
              </article>

              <article className="footer-col">
                <h4>follow us</h4>
                <article className="social-links">
                  <a href="#g">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#g">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#g">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#g">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </article>
              </article>
            </article>
          </article>
        </footer>
        <p className="text-center text-sm">
          © Copyright 2023 247Comcare. All rights reserved.
        </p>
        </>
    )
}
export default Footer;